
var ViewFactory = require('tplify/dist/viewFactory').default;

delete module.exports;

var viewFactory = new ViewFactory('<section data-name="headerRegion" class="mainPresenter-header"></section>\n<section data-name="resultsRegion" class="mainPresenter-results"></section>\n<div class="mainPresenter-logoBottom"><img src="img/tim_logo_black.svg"></div>\n');

Object.defineProperty(module, 'exports', {
get: function() {
    return viewFactory.create();
}
});
